<template>
  <h1 class="custom-h1" block>Meine Charaktere</h1>
  <v-container d-flex>

    <h2 class="custom-h2" v-if="sortedCharaktereDnD.length > 0" block>D&D 5e</h2>
    <v-row no-gutters>
      <v-col cols="12" xs="12" sm="6" md="4" v-for="charakter in sortedCharaktereDnD" :key="charakter.id">
        <v-card link style="margin: 8px" @click="OpenCharacter(charakter.id, charakter.System)">
          <v-card-title class="d-flex justify-space-between align-center">
            <div>{{ charakter.Name }}</div>
            <v-avatar size="55">
              <v-img :src="imagePath(charakter)" />
            </v-avatar>
          </v-card-title>
          <v-card-subtitle>{{ charakter.System }}</v-card-subtitle>
          <v-card-text style="font-size: 0.5em; text-align: right;">ID: {{ charakter.id }}</v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <h2 class="custom-h2" v-if="sortedCharaktereDSA.length > 0" block>DSA 4.1</h2>
    <v-row no-gutters>
      <v-col cols="12" xs="12" sm="6" md="4" v-for="charakter in sortedCharaktereDSA" :key="charakter.id">
        <v-card link style="margin: 8px" @click="OpenCharacter(charakter.id, charakter.System)">
          <v-card-title class="d-flex justify-space-between align-center">
            <div>{{ charakter.Name }}</div>
            <v-avatar size="55">
              <v-img :src="imagePath(charakter)" />
            </v-avatar>
          </v-card-title>
          <v-card-subtitle>{{ charakter.System }}</v-card-subtitle>
          <v-card-text style="font-size: 0.5em; text-align: right;">ID: {{ charakter.id }}</v-card-text>
        </v-card>
      </v-col>
    </v-row>
    
    <h2 class="custom-h2" v-if="sortedCharaktereShadowrun.length > 0" block>Shadowrun 5e</h2>
    <v-row no-gutters>
      <v-col cols="12" xs="12" sm="6" md="4" v-for="charakter in sortedCharaktereShadowrun" :key="charakter.id">
        <v-card link style="margin: 8px" @click="OpenCharacter(charakter.id, charakter.System)">
          <v-card-title class="d-flex justify-space-between align-center">
            <div>{{ charakter.Name }}</div>
            <v-avatar size="55">
              <v-img :src="imagePath(charakter)" />
            </v-avatar>
          </v-card-title>
          <v-card-subtitle>{{ charakter.System }}</v-card-subtitle>
          <v-card-text style="font-size: 0.5em; text-align: right;">ID: {{ charakter.id }}</v-card-text>
        </v-card>
      </v-col>
    </v-row>
    
    <h2 class="custom-h2" v-if="sortedCharaktereGötterlicht.length > 0" block>Götterlicht</h2>
    <v-row no-gutters>
      <v-col cols="12" xs="12" sm="6" md="4" v-for="charakter in sortedCharaktereGötterlicht" :key="charakter.id">
        <v-card link style="margin: 8px" @click="OpenCharacter(charakter.id, charakter.System)">
          <v-card-title class="d-flex justify-space-between align-center">
            <div>{{ charakter.Name }}</div>
            <v-avatar size="55">
              <v-img :src="imagePath(charakter)" />
            </v-avatar>
          </v-card-title>
          <v-card-subtitle>{{ charakter.System }}</v-card-subtitle>
          <v-card-text style="font-size: 0.5em; text-align: right;">ID: {{ charakter.id }}</v-card-text>
        </v-card>
      </v-col>
    </v-row>
    
    <h2 class="custom-h2" v-if="this.ocharaktere.length > 0" block>Freigegebene Charaktere</h2>
    <v-row no-gutters>
      <v-col cols="12" xs="12" sm="6" md="4" v-for="charakter in this.ocharaktere" :key="charakter.id">
        <v-card link style="margin: 8px" @click="OpenCharacterR(charakter.id, charakter.System)">
          <v-card-title class="d-flex justify-space-between align-center">
            <div>{{ charakter.Name }}</div>
            <v-avatar size="55">
              <v-img :src="imagePath(charakter)" />
            </v-avatar>
          </v-card-title>
          <v-card-subtitle>{{ charakter.System }}</v-card-subtitle>
          <v-card-text style="font-size: 0.5em; text-align: right;">ID: {{ charakter.id }}</v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <h2 class="custom-h2" block>Neuen Charakter anlegen</h2>
    <v-row>
      <v-col>
        <v-card style="margin: 8px; margin-top: 25px; display: flex; flex-direction: column;">
          <v-card-title>Neuer Charakter</v-card-title>
          <v-text-field label="Name" v-model="newCharName" />
          <v-select v-model="newCharSystem" label="System" :items="systeme" />
          <v-btn @click="newChar" :disabled="!newCharName || !newCharSystem" class="custom-button"
            style="margin: 10px;">Neu</v-btn>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import logger from '@/utils/logger.js'
import { db } from '@/firebase.js'
import { collection, query, where, /*orderBy,*/ onSnapshot, addDoc, serverTimestamp } from 'firebase/firestore';
import { dsaProben } from '@/composables/useDSAProben.js'
import { dndProben } from '@/composables/useDNDProben.js'
import { srProben } from '@/composables/useSRProben.js'

export default {
  data() {
    return {
      charaktere: [],
      ocharaktere: [],
      newCharName: '',
      newCharSystem: '',
      newCharDSAProben: [],
      newCharDNDProben: [],
      newCharSRProben: [],
    };
  },

  computed: {
    systeme() {
      return this.$store.state.systeme
    },
    sortedCharaktere() {
      return [...this.charaktere].sort((a, b) => {
        if (a.System === b.System) {
          return a.Name.localeCompare(b.Name);
        }
        return a.System.localeCompare(b.System);
      });
    },
    sortedCharaktereDnD() {
      return this.sortedCharaktere.filter(char => char.System === "D&D 5e");
    },

    sortedCharaktereDSA() {
      return this.sortedCharaktere.filter(char => char.System === "DSA 4.1");
    },

    sortedCharaktereShadowrun() {
      return this.sortedCharaktere.filter(char => char.System === "Shadowrun 5e");
    },

    sortedCharaktereGötterlicht() {
      return this.sortedCharaktere.filter(char => char.System === "Götterlicht");
    }
  },

  mounted() {
    if (!this.$store.state.User) {
      logger.log('Auf Willkommensseite umgeleitet.')
      this.$router.push({ name: 'home' })
    } else {
      this.loadCharaktere()
      this.loadoCharaktere()
    }
  },

  methods: {
    loadCharaktere() {
      const q = query(
        collection(db, "Charaktere"),
        where("User", "==", this.$store.state.User.uid)
      )
      onSnapshot(q, (querySnapshot) => {
        this.charaktere = querySnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
      });
    },

    loadoCharaktere() {
      const q = query(
        collection(db, "Charaktere"),
        where("oUsers", "array-contains", this.$store.state.User.uid)
      )
      onSnapshot(q, (querySnapshot) => {
        this.ocharaktere = querySnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
      });
    },

    async newChar() {
      const colRefChars = collection(db, 'Charaktere')

      if (this.newCharSystem == 'D&D 5e') {
        this.newCharDNDProben = dndProben()
        await addDoc(colRefChars, {
          Name: this.newCharName,
          System: this.newCharSystem,
          User: this.$store.state.User.uid,
          CreatedAt: serverTimestamp(),
          csWebhook: '',

          Str: 0,
          Ges: 0,
          Kon: 0,
          Int: 0,
          Wei: 0,
          Cha: 0,
          Notizen: '',
          Notizen1: '',
          Notizen2: '',
          Notizen3: '',
          Übungsbonus: 2,
          customRolls: this.newCharDNDProben
        })

      } else if (this.newCharSystem == 'DSA 4.1') {
        this.newCharDSAProben = dsaProben()
        await addDoc(colRefChars, {
          Name: this.newCharName,
          System: this.newCharSystem,
          User: this.$store.state.User.uid,
          CreatedAt: serverTimestamp(),          
          csWebhook: '',

          Mut: 10,
          Klugheit: 10,
          Intuition: 10,
          Charisma: 10,
          Fingerfertigkeit: 10,
          Gewandtheit: 10,
          Konstitution: 10,
          Körperkraft: 10,
          Proben: this.newCharDSAProben
        })

      } else if (this.newCharSystem == 'Shadowrun 5e') {
        this.newCharSRProben = srProben()
        await addDoc(colRefChars, {
          Name: this.newCharName,
          System: this.newCharSystem,
          User: this.$store.state.User.uid,
          CreatedAt: serverTimestamp(),          
          csWebhook: '',

          Konstitution: 0,
          Geschicklichkeit: 0,
          Reaktion: 0,
          Stärke: 0,
          Charisma: 0,
          Intuition: 0,
          Logik: 0,
          Willenskraft: 0,
          Edge: 0,
          Magie: 0,
          HatMagie: false,
          Resonanz: 0,
          HatResonanz: false,
          Panzerung: 0,
          Gerätestufe: 0,
          Datenverarbeitung: 0,
          Firewall: 0,
          Schleicher: 0,
          Angriff: 0,
          Proben: this.newCharSRProben
        })

      } else if (this.newCharSystem == 'Götterlicht') {
        await addDoc(colRefChars, {
          Name: this.newCharName,
          System: this.newCharSystem,
          User: this.$store.state.User.uid,
          CreatedAt: serverTimestamp(),

          csWebhook: '',

          KlasseOffen: '',
          KlasseVersteckt: '',
          KlasseVerdeckt: '',

          EPGesamt: 0,
          EPAktuell: 100,
          EPSonderfertigkeiten: 0,

          Leben: 0,
          Mana: 4,

          Magieattribute: '',

          Nahkampf: 0,
          Fernkampf: 0,
          Initiative: 0,

          Ausweichen: 0,
          Abwehren: 0,
          Magieverteidigung: 0,          
          Willenskraft: 0,

          Kraftakt: 0,
          Geschicklichkeit: 0,
          Heimlichkeit: 0,
          Fingerfertigkeit: 0,

          Sinnesschärfe: 0,
          Nachforschung: 0,
          Überlebenskunst: 0,
          Handwerk: 0,

          Heilkunde: 0,
          Magie: 0,
          Wissen: 0,
          Kosmologie: 0,

          Beeinflussen: 0,
          Täuschen: 0,
          Einschätzen: 0,
          Handeln: 0
        })

      } else {
        await addDoc(colRefChars, {
          Name: this.newCharName,
          System: this.newCharSystem,
          User: this.$store.state.User.uid,
          CreatedAt: serverTimestamp(),
          csWebhook: ''
        })
      }
      this.$store.commit('callSnackbar', "Charakter erfolgreich angelegt.")
      this.newCharName = ""
      this.newCharSystem = ""
    },

    viewNameForSystem(system) {
      if (system == 'D&D 5e') return 'CharDNDView'
      if (system == 'DSA 4.1') return 'CharDSAView'
      if (system == 'Shadowrun 5e') return 'CharSRView'
      if (system == 'Götterlicht') return 'CharGLView'
      return 'CharakterView'
    },

    OpenCharacter(id, system) {
      this.$store.commit('setState', { key: 'activeCharID', value: id })
      this.$router.push({ name: this.viewNameForSystem(system), query: { id } })
    },

    OpenCharacterR(id, system) {
      this.$store.commit('setState', { key: 'activeCharID', value: id })
      this.$router.push({ name: this.viewNameForSystem(system), query: { id, ro: '1' } })
    },

    imagePath(charakter) {
      try {
        let result = ''
        if (charakter.picURL) {
          result = charakter.picURL
        }
        else {
          result = require(`@/assets/SysPic/${charakter.System}.png`)
        }
        return result;
      } catch (e) {
        console.error(e);
        return '';
      }
    }

  }
}
</script>
